import React from 'react'
import styles from './Category.module.css'

export const Category = ({
  category,
  isSelected,
  onCategoryClick,
  variant = 'big',
}) => {
  return (
    <span
      style={{ background: isSelected ? category.color : '#bbb' }}
      className={`${styles.category} ${
        variant === 'big' ? styles.variantBig : styles.variantSmall
      }`}
      onClick={() => {
        onCategoryClick()
      }}
    >
      <img src={category.img} alt={category.name} />
      <p>{category.name}</p>
    </span>
  )
}
